interface Configuration {
    apiUrl: string;
    usePlaceHolder: boolean;
    gtmId: string;
}

const global = { 
    gtmId: 'GTM-PT2GT6RG' 
};

const local = {
    ...global,
    apiUrl: 'https://localhost:58185',
}

const dev = {
    ...global,
    apiUrl: 'https://dev-apigw.lojump.xyz',
}

const qa = {
    ...global,
    apiUrl: 'https://qa-apigw.lojump.xyz',
}

const stage = {
    ...global,
    apiUrl: 'https://stage-apigw.hidive.com',
}

const prod = {
    ...global,
    apiUrl: 'https://apigw.hidive.com',
}

const GetConfiguration = () => {
    switch (process.env.REACT_APP_STAGE) {
        case 'prod':
            return prod;
        case 'stage':
            return stage
        case 'qa':
            return qa;
        case 'dev':
            return dev;
        default:
            return local;
    }
}

let config = GetConfiguration();

let result: Configuration = {
    ...config,
    usePlaceHolder: process.env.REACT_APP_USE_PLACEHOLDER === 'true'
}

export default result;
